/* eslint-disable @typescript-eslint/no-explicit-any */
import { clowncar } from 'types';

import { ImportData } from 'routes/logged-in/imports/ImporterRoute';
import { createImporterConfig } from 'utils/importerUtils';
import { createWorkflowActions } from '@tock/shared/workflow/actionCreators';
import { stringify } from '@tock/query-string';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { PreImportReportInformation } = protos;

export function validateFile(
  file: any,
  input: ImportData,
  fileName: any,
  fileType: number
): ApiAction {
  const { formatVersion, separator, guestFullNameOrder, resoFullNameOrder } =
    createImporterConfig(input);
  const queryParams = stringify({
    formatVersion,
    separator,
    fileName,
    fileType,
    guestFullNameOrder,
    resoFullNameOrder,
  });

  return {
    TockApi: {
      postFile: `/async/data/import/validate-files/${input.businessId}?${queryParams}`,
      type: ClowncarAppConstants.IMPORT_WORKFLOW_CREATED,
      request: file,
    },
  };
}

export function generateReport(request: clowncar.IPreImportReportInformation): ApiAction {
  return {
    TockApi: {
      postProto: `/async/data/import/report/`,
      type: ClowncarAppConstants.IMPORT_WORKFLOW_CREATED,
      request: PreImportReportInformation.fromObject(request),
    },
  };
}

export const { fetchWorkflowStatus: validateFileStatus, fetchWorkflowResult: validateFileResult } =
  createWorkflowActions({
    statusType: ClowncarAppConstants.NULL,
    resultType: ClowncarAppConstants.IMPORT_REPORT_VALIDATE_FILE,
    errorType: ClowncarAppConstants.IMPORT_REPORT_VALIDATE_FILE_FAILED,
  });

export const {
  fetchWorkflowStatus: generateReportStatus,
  fetchWorkflowResult: generateReportResult,
} = createWorkflowActions({
  statusType: ClowncarAppConstants.NULL,
  resultType: ClowncarAppConstants.PRE_IMPORT_REPORT_GENERATE_DONE,
  errorType: ClowncarAppConstants.PRE_IMPORT_REPORT_GENERATE_FAILED,
  protoType: PreImportReportInformation,
});
